<template>
    <div>
        <div v-if="isFallback" class="text-muted small mb-2">
            기본 템플릿은 조건 없이 동작합니다.
        </div>
        <div v-else>
            <!-- 행/select 는 키 변경에도 유지해야 @change(nextTick 발생)가 도착한다. picker 만 키별로 새로 만든다. -->
            <div
                v-for="(row, idx) in rows"
                :key="idx"
                class="mb-2"
            >
                <div class="d-flex align-items-start">
                    <b-form-select
                        v-model="row.key"
                        :options="availableKeys(idx)"
                        size="sm"
                        style="width: 130px;"
                        :disabled="disabled"
                        @change="onKeyChange(row)"
                    />
                    <ConditionValuePicker
                        :key="row.key"
                        v-model="row.value"
                        class="flex-grow-1 mx-1"
                        :entity="entityOf(row.key)"
                        :disabled="disabled || !row.key"
                        @input="emitChange"
                    />
                    <b-button
                        variant="outline-danger"
                        size="sm"
                        class="py-0 px-1"
                        :disabled="disabled"
                        @click="removeRow(idx)"
                    >×</b-button>
                </div>
            </div>
            <b-button
                variant="outline-secondary"
                size="sm"
                :disabled="disabled"
                @click="addRow"
            >+ 조건 추가</b-button>
            <small class="text-muted d-block mt-2">
                여러 개를 고르면 그중 하나라도 맞을 때 적용됩니다.
            </small>
        </div>
    </div>
</template>

<script>
import { CONTEXT_KEYS } from '../data'
import ConditionValuePicker from '../../_common/ConditionValuePicker.vue'

export default {
    name: 'SimpleContextBuilder',
    components: { ConditionValuePicker },
    props: {
        value: { type: Object, default: () => ({}) },
        disabled: { type: Boolean, default: false },
        isFallback: { type: Boolean, default: false },
    },
    data() {
        return {
            // { key, value } — value 는 저장 문자열 원문('568', 'a|b', '[1-5]').
            rows: [],
            keyOptions: CONTEXT_KEYS,
            selfEmitted: false,
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (this.selfEmitted) {
                    this.selfEmitted = false
                    return
                }
                if (!val || Object.keys(val).length === 0) {
                    if (this.rows.length === 0 || !this.rows.some(r => r.key)) {
                        this.rows = []
                    }
                    return
                }
                this.rows = Object.entries(val).map(([key, rawValue]) => ({
                    key,
                    value: rawValue == null ? '' : String(rawValue),
                }))
            },
        },
        isFallback(val) {
            if (val) {
                this.rows = []
                this.emitChange()
            }
        },
    },
    methods: {
        entityOf(key) {
            const keyDef = this.keyOptions.find(k => k.value === key)
            return keyDef ? keyDef.entity : ''
        },
        // 키만 고르고 값을 비워 둔 행(저장 차단용 — 부모가 ref 로 호출).
        hasIncompleteRow() {
            return this.rows.some(r => r.key && !r.value)
        },
        onKeyChange(row) {
            // 다른 대상의 ID/코드는 의미가 없으므로 값을 비운다.
            row.value = ''
            this.emitChange()
        },
        availableKeys(currentIdx) {
            const usedKeys = this.rows
                .filter((_, i) => i !== currentIdx)
                .map(r => r.key)
            const opts = [{ value: '', text: '선택...' }]
            this.keyOptions.forEach(k => {
                opts.push({
                    value: k.value,
                    text: k.label,
                    disabled: usedKeys.includes(k.value),
                })
            })
            return opts
        },
        addRow() {
            this.rows.push({ key: '', value: '' })
        },
        removeRow(idx) {
            this.rows.splice(idx, 1)
            this.emitChange()
        },
        emitChange() {
            const obj = {}
            this.rows.forEach(r => {
                if (r.key && r.value) obj[r.key] = r.value
            })
            this.selfEmitted = true
            this.$emit('input', obj)
        },
    },
}
</script>
